import React, { useCallback, useEffect } from 'react'
import { TopicEmailSubscriptionPeriod } from '../models/topicEmailSubscriptionPeriod'
import { useEndpoint } from './endpoint'
import * as api from '../api/comments-api'

export const useTopicEmailSubscription = (topicId: string) => {
  const [period, setPeriod] = React.useState<TopicEmailSubscriptionPeriod>()
  const getTopicEmailSubscription = useEndpoint(api.getTopicEmailSubscription)
  const subscribeTopicEmails = useEndpoint(api.subscribeTopicEmails)

  useEffect(() => {
    getTopicEmailSubscription({ topicId }).then(({ period }) => {
      setPeriod(period)
    })

    // We don't want to call endpoint again when google token is refreshed, that's why we don't add
    // getTopicEmailSubscription to the dependency array.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [topicId])

  const onSubscribeTopicEmails = useCallback(
    (params: api.SubscribeTopicEmailParams) =>
      subscribeTopicEmails(params).then(() => {
        setPeriod(params.period)
      }),
    [subscribeTopicEmails]
  )

  return { period, onSubscribeTopicEmails }
}
